import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export function hasCyrillicCharactersValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const hasCyrillicCharactersRe = /[\u0401\u0451\u0410-\u044f]+/i;
        const hasCyrillicCharacters = hasCyrillicCharactersRe.test(control.value);
        return hasCyrillicCharacters ? { cyrillic: { value: control.value } } : null;
    };
}

export function emailValidator(): ValidatorFn {
    return Validators.pattern(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}

export function minSize(size: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null =>
        control.value.length >= size ? null : { length: control.value.length };
}
